import { IntegrationModeSetting } from 'models/ppoints/settings/SettingsToEcom';
import { nativeEnum, object, string, ZodIssueCode } from 'zod';

const integrationModeStepSchema = object({
    integrationMode: nativeEnum(IntegrationModeSetting, {
        required_error: 'WIZARD.INTEGRATION_MODE_STEP.MODE_REQUIRED',
        invalid_type_error: 'WIZARD.INTEGRATION_MODE_STEP.MODE_REQUIRED',
    }),
    googleMapApiKey: string().optional(),
}).superRefine((data, ctx) => {
    // The Thank you page map is rendered with the merchant's own Google Maps key, so it can't be
    // activated without one.
    if (data.integrationMode !== IntegrationModeSetting.thank_you_page_map) return;

    if (!data.googleMapApiKey?.trim()) {
        ctx.addIssue({
            code: ZodIssueCode.custom,
            path: ['googleMapApiKey'],
            message: 'SETTINGS.THANK_YOU_PAGE_MAP_INTEGRATION.GOOGLE_API_KEY_REQUIRED',
        });
    }
});

export default integrationModeStepSchema;
